export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/frontend/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/:notfound(.*)',
    name: '/[...notfound]',
    component: () => import('/frontend/src/pages/[...notfound].vue'),
    /* no children */
  },
  {
    path: '/dashboard',
    name: '/dashboard',
    component: () => import('/frontend/src/pages/dashboard.vue'),
    /* no children */
  },
  {
    path: '/events',
    name: '/events',
    component: () => import('/frontend/src/pages/events.vue'),
    children: [
      {
        path: 'alerts',
        name: '/events/alerts',
        component: () => import('/frontend/src/pages/events/alerts.vue'),
        /* no children */
      },
      {
        path: 'firewall',
        name: '/events/firewall',
        component: () => import('/frontend/src/pages/events/firewall.vue'),
        /* no children */
      },
      {
        path: 'netflow',
        name: '/events/netflow',
        component: () => import('/frontend/src/pages/events/netflow.vue'),
        /* no children */
      },
      {
        path: 'process',
        name: '/events/process',
        component: () => import('/frontend/src/pages/events/process.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/excludes',
    name: '/excludes',
    component: () => import('/frontend/src/pages/excludes.vue'),
    /* no children */
  },
  {
    path: '/forgot-password',
    name: '/forgot-password',
    component: () => import('/frontend/src/pages/forgot-password.vue'),
    /* no children */
  },
  {
    path: '/general-settings',
    name: '/general-settings',
    component: () => import('/frontend/src/pages/general-settings.vue'),
    children: [
      {
        path: 'general',
        name: '/general-settings/general',
        component: () => import('/frontend/src/pages/general-settings/general.vue'),
        /* no children */
      },
      {
        path: 'license',
        name: '/general-settings/license',
        component: () => import('/frontend/src/pages/general-settings/license.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/hosts',
    name: '/hosts',
    component: () => import('/frontend/src/pages/hosts.vue'),
    children: [
      {
        path: 'external',
        name: '/hosts/external',
        component: () => import('/frontend/src/pages/hosts/external.vue'),
        /* no children */
      },
      {
        path: 'groups',
        name: '/hosts/groups',
        component: () => import('/frontend/src/pages/hosts/groups.vue'),
        /* no children */
      },
      {
        path: 'network',
        name: '/hosts/network',
        component: () => import('/frontend/src/pages/hosts/network.vue'),
        /* no children */
      },
      {
        path: 'tags',
        name: '/hosts/tags',
        component: () => import('/frontend/src/pages/hosts/tags.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('/frontend/src/pages/login.vue'),
    /* no children */
  },
  {
    path: '/network',
    name: '/network',
    component: () => import('/frontend/src/pages/network.vue'),
    /* no children */
  },
  {
    path: '/notifications',
    name: '/notifications',
    component: () => import('/frontend/src/pages/notifications.vue'),
    children: [
      {
        path: 'channels',
        name: '/notifications/channels',
        component: () => import('/frontend/src/pages/notifications/channels.vue'),
        /* no children */
      },
      {
        path: 'rules',
        name: '/notifications/rules',
        component: () => import('/frontend/src/pages/notifications/rules.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/register',
    name: '/register',
    component: () => import('/frontend/src/pages/register.vue'),
    /* no children */
  },
  {
    path: '/restore-password',
    name: '/restore-password',
    component: () => import('/frontend/src/pages/restore-password.vue'),
    /* no children */
  },
  {
    path: '/rules',
    name: '/rules',
    component: () => import('/frontend/src/pages/rules.vue'),
    children: [
      {
        path: 'current',
        name: '/rules/current',
        component: () => import('/frontend/src/pages/rules/current.vue'),
        /* no children */
      },
      {
        path: 'log',
        name: '/rules/log',
        component: () => import('/frontend/src/pages/rules/log.vue'),
        /* no children */
      },
      {
        path: 'recommendations',
        name: '/rules/recommendations',
        component: () => import('/frontend/src/pages/rules/recommendations.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/settings-auth',
    name: '/settings-auth',
    component: () => import('/frontend/src/pages/settings-auth.vue'),
    /* no children */
  },
  {
    path: '/templates',
    name: '/templates',
    component: () => import('/frontend/src/pages/templates.vue'),
    /* no children */
  },
  {
    path: '/user-settings',
    name: '/user-settings',
    component: () => import('/frontend/src/pages/user-settings.vue'),
    children: [
      {
        path: 'profile',
        name: '/user-settings/profile',
        component: () => import('/frontend/src/pages/user-settings/profile.vue'),
        /* no children */
      },
      {
        path: 'segments',
        name: '/user-settings/segments',
        component: () => import('/frontend/src/pages/user-settings/segments.vue'),
        /* no children */
      },
      {
        path: 'users',
        name: '/user-settings/users',
        component: () => import('/frontend/src/pages/user-settings/users.vue'),
        /* no children */
      }
    ],
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

